import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'
import ButtonImportProductsFromXls from '../_DESIGN/PropertiesPaneButtonImportProductsFromXls.jsx'
import ButtonExportStructure from '../components/PropertiesPaneButtonExportStructure.jsx'
import ButtonPreview from './PropertiesPaneButtonPreview.jsx'

export default function PropertiesPaneUa(props) {
    return (
        <ArchPropertiesPane
            buttons={
                <>
                    <ButtonImportProductsFromXls type="um">
                        导入入口结构
                    </ButtonImportProductsFromXls>

                    <ButtonExportStructure type="ua">导出界面结构</ButtonExportStructure>

                    <ButtonPreview />
                </>
            }

            {...props}
        />
    )
}
